<fa-icon
    *ngIf="iconDeserialised"
    nz-tooltip
    [nzTooltipTitle]="tooltip"
    [nzTooltipPlacement]="'right'"
    [icon]="iconDeserialised"
    [ngStyle]="{color: getColor()}"></fa-icon>
